
import React, { useEffect, useState } from 'react';
import { API_URLS } from '../apiUrl';
import axiosInstance from './axiosInstance';

interface LoginProps {
    onLogin: (role_id: number, muniCipalityName: string, muniCipalityId: any, municipalityLogo: any, banner_image: any,token: any,role_name:any) => void; // Change the onLogin function to accept role_id
}

export const Login: React.FC<LoginProps> = ({ onLogin }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();

        setError(null);
        setIsLoading(true);
     
        try {
            const response = await axiosInstance.post(API_URLS.LoginApi, {
                login_user_name: email,
                password: password,
            });

            if (response.status === 200) {
             localStorage.setItem("token",   response.data.user.token);
             localStorage.setItem("user_id", response.data.user.id);
             localStorage.setItem("role_id", response.data.user.role_id);

            const roleResponse = await axiosInstance.post(API_URLS.userroledetails,
                {
                  collector_id: response.data.user.id
                }
            );
            const loacldata = roleResponse.data?.data
            if(loacldata.role_type === "Field Collector"){
            localStorage.setItem("ward", loacldata.ward_no || "");            }
            localStorage.setItem('user_name',loacldata.admin_name)
            localStorage.setItem('role_type',loacldata.role_type)
            localStorage.setItem('municipality_id_v2',loacldata.municipality_id)
            localStorage.setItem('municipality_name_v2',loacldata.municipality_name)

            onLogin(
                       response.data.user.role_id,
                       response.data.user.municipality_name,
                       response.data.user.id,
                       response.data.user.logo,
                       response.data.user.banner_image,
                       response.data.user.token,
                       response.data.user.role_name);
            }
        } catch (error: any) {
            setError('Invalid username or password. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const storedEmail = localStorage.getItem("municipalityLoginId");
        const password = localStorage.getItem("municipalityAccessKey");
        if (storedEmail && password) {
            setEmail(storedEmail); 
            setPassword(password);
        }
    }, []);

    return (
        <>
            <div className="bg-gray-100">
                <div className="min-h-screen flex items-center justify-center">
                    <div className="max-w-md w-full p-6 bg-white rounded-lg shadow-lg">
                        <div className="flex justify-center mb-4">
                            <img src="/assets/surveyLogo.png" alt="Logo" className="w-36 h-30" />
                        </div>
                        <h1 className="text-2xl font-semibold text-center text-gray-800 mt-8 mb-6">PROPERTY SURVEY</h1>
                        <form onSubmit={handleSubmit}>
                            <div className="mb-6">
                                <label htmlFor="email" className="block mb-2 text-sm text-gray-600">Username <span className="text-red-600">*</span></label>
                                <input
                                    type="text"
                                    id="email"
                                    name="email"
                                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                         <div className="mb-6">
  <label
    htmlFor="password"
    className="block mb-2 text-sm text-gray-600"
  >
    Password <span className="text-red-600">*</span>
  </label>

  <div className="relative">
    <input
      type={showPassword ? "text" : "password"}
      id="password"
      name="password"
      className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 pr-10"
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      required
    />

    {/* Toggle Icon */}
    <button
      type="button"
      onClick={() => setShowPassword(!showPassword)}
      className="absolute inset-y-0 right-3 flex items-center text-gray-500"
    >
      <i className={showPassword ? "ri-eye-off-line" : "ri-eye-fill"}></i>
    </button>
  </div>
</div>
                            {error && (
                                <div className="text-red-500 text-sm mb-4">{error}</div>
                            )}
                            <button
                                type="submit"
                                className="w-32 bg-gradient-to-r from-cyan-400 to-cyan-600 text-white py-2 rounded-lg mx-auto block focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 mt-4 mb-6"
                                disabled={isLoading}
                            >
                                {isLoading ? 'Logging in...' : 'Submit'}
                            </button>
                        </form>
                        <p className="text-xs text-gray-600 text-center mt-10">&copy; 2026 SURVEY</p>
                    </div>
                </div>
            </div>

        </>
    );
};

